module.exports = __webpack_public_path__ + "static/media/cq_richieste_scadute.491ed023.svg";